"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _ContestBanner = _interopRequireDefault(require("./banner/ContestBanner"));

var _HowToPlay = _interopRequireDefault(require("./howToPlay/HowToPlay"));

var _ContestPicks = _interopRequireDefault(require("./picks/ContestPicks"));

var _ContestBetNow = _interopRequireDefault(require("./ContestBetNow"));

var _ContestMakePicks = _interopRequireDefault(require("./ContestMakePicks"));

var _ContestFloatingHeaderVerify = _interopRequireDefault(require("./ContestFloatingHeaderVerify"));

var _ScoresShareButton = _interopRequireDefault(require("./ScoresShareButton"));

var _defaultTranslations = _interopRequireDefault(require("./defaultTranslations"));

var _actions = require("./actions");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Contest = function Contest(_ref) {
  var _app$profile3;

  var translations = _ref.translations,
      language = _ref.language,
      betbarParent = _ref.betbarParent,
      setBetbarParent = _ref.setBetbarParent,
      app = _ref.app,
      isMobileVerificationDisabled = _ref.isMobileVerificationDisabled,
      isClearingPicks = _ref.isClearingPicks,
      isLoggedIn = _ref.isLoggedIn,
      isUsingAlternativeImages = _ref.isUsingAlternativeImages,
      isHowToPlayAboveBanner = _ref.isHowToPlayAboveBanner,
      hidePopularPick = _ref.hidePopularPick,
      hideMakeYourPicks = _ref.hideMakeYourPicks,
      onPicksCleared = _ref.onPicksCleared,
      onPicksChanged = _ref.onPicksChanged,
      onPlaceBetClicked = _ref.onPlaceBetClicked,
      onRulesClicked = _ref.onRulesClicked,
      onTermsAndConditionsClicked = _ref.onTermsAndConditionsClicked,
      GameBanner = _ref.GameBanner,
      hasCheckboxes = _ref.hasCheckboxes,
      hasQuestionStatBelowQuestion = _ref.hasQuestionStatBelowQuestion,
      hasSocialShareButton = _ref.hasSocialShareButton;
  var dispatch = (0, _reactRedux.useDispatch)(); // usePusherContest();

  var _useState = (0, _react.useState)(hasCheckboxes ? {
    over18: false,
    marketing: false
  } : undefined),
      _useState2 = _slicedToArray(_useState, 2),
      consentCheckboxes = _useState2[0],
      setConsetCheckboxes = _useState2[1];

  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.contest;
  }),
      isAllSelected = _useSelector.isAllSelected,
      picks = _useSelector.picks;

  var activePickem = betbarParent.activePickem,
      activeBet = betbarParent.activeBet,
      isContestEmpty = betbarParent.isContestEmpty,
      isPlacingBet = betbarParent.isPlacingBet;
  var isScrolledDown = app.isScrolledDown,
      isNonUkUser = app.isNonUkUser,
      isIdentityPassed = app.isIdentityPassed,
      isMobileNumberVerified = app.isMobileNumberVerified,
      walletBalance = app.walletBalance,
      walletPromoBalance = app.walletPromoBalance;
  (0, _react.useEffect)(function () {
    dispatch((0, _actions.getCoolingOffDuration)());
  }, []);
  (0, _react.useEffect)(function () {
    if (translations) {
      dispatch((0, _actions.setContest)({
        translations: translations
      }));
    }
  }, [translations, dispatch]);
  (0, _react.useEffect)(function () {
    var _app$profile;

    if (app !== null && app !== void 0 && (_app$profile = app.profile) !== null && _app$profile !== void 0 && _app$profile.dataSharePermissions) {
      var _app$profile2, _app$profile2$dataSha, _app$profile2$dataSha2;

      setConsetCheckboxes(_objectSpread(_objectSpread({}, consentCheckboxes), {}, {
        marketing: app === null || app === void 0 ? void 0 : (_app$profile2 = app.profile) === null || _app$profile2 === void 0 ? void 0 : (_app$profile2$dataSha = _app$profile2.dataSharePermissions) === null || _app$profile2$dataSha === void 0 ? void 0 : (_app$profile2$dataSha2 = _app$profile2$dataSha.find(function (obj) {
          return obj.type === "PARTNER_EMAIL_ACCEPTED";
        })) === null || _app$profile2$dataSha2 === void 0 ? void 0 : _app$profile2$dataSha2.value
      }));
    }
  }, [app === null || app === void 0 ? void 0 : (_app$profile3 = app.profile) === null || _app$profile3 === void 0 ? void 0 : _app$profile3.dataSharePermissions]);
  (0, _react.useEffect)(function () {
    if (activePickem !== null && activePickem !== void 0 && activePickem.id) {
      dispatch((0, _actions.setPicks)(undefined));
    }
  }, [activePickem === null || activePickem === void 0 ? void 0 : activePickem.id]);
  (0, _react.useEffect)(function () {
    if (activeBet !== null && activeBet !== void 0 && activeBet.selections) {
      dispatch((0, _actions.setPicks)(activeBet === null || activeBet === void 0 ? void 0 : activeBet.selections));
    }
  }, [activeBet === null || activeBet === void 0 ? void 0 : activeBet.selections]);
  (0, _react.useEffect)(function () {
    console.log("isClearingPicks", isClearingPicks);

    if (isClearingPicks) {
      dispatch((0, _actions.setContest)({
        picks: {}
      }));
      onPicksCleared();
    }
  }, [isClearingPicks]);
  (0, _react.useEffect)(function () {
    window.xtremepush("tag", "lobby", JSON.stringify({
      AppName: process.env.REACT_APP_TITLE
    }));
  }, []);
  var isLocked = (activePickem === null || activePickem === void 0 ? void 0 : activePickem.stake) > 0 && walletBalance + walletPromoBalance < (activePickem === null || activePickem === void 0 ? void 0 : activePickem.stake) || //!isIdentityPassed ||
  !isMobileVerificationDisabled && isMobileNumberVerified === false || activePickem && activePickem.status === "IN_PLAY" || activePickem && activePickem.status === "COMPLETED" || activeBet && activePickem && activePickem.questions && activeBet.selections && Object.keys(activeBet.selections).length === activePickem.questions.length ? true : false;

  var questionAnswered = function questionAnswered(value) {
    return value > 0;
  };

  (0, _react.useEffect)(function () {
    var selectionsAreComplete = !isLocked && activePickem && activePickem.questions && picks && Object.keys(picks).every(function (q) {
      return questionAnswered(picks[q]);
    }) && Object.keys(picks).length === activePickem.questions.length;

    if (selectionsAreComplete && !isAllSelected) {
      dispatch((0, _actions.setAllSelected)(selectionsAreComplete));
    } else if (isAllSelected && !selectionsAreComplete) {
      dispatch((0, _actions.setAllSelected)(selectionsAreComplete));
    }
  }, [isLocked, activePickem, picks, dispatch, isAllSelected]);

  var updatePicks = function updatePicks(id, option) {
    var newPicks = _objectSpread({}, picks);

    newPicks[id] = option.id;
    dispatch((0, _actions.setPicks)(newPicks));

    if (onPicksChanged) {
      var _activePickem$questio, _Object$keys;

      console.log("onPicksChanged", id, option, newPicks);
      onPicksChanged({
        picks: newPicks,
        questionsTotal: activePickem === null || activePickem === void 0 ? void 0 : (_activePickem$questio = activePickem.questions) === null || _activePickem$questio === void 0 ? void 0 : _activePickem$questio.length,
        questionsAnswered: Object === null || Object === void 0 ? void 0 : (_Object$keys = Object.keys(newPicks)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length
      });
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [!isMobileVerificationDisabled && isMobileNumberVerified === false && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContestFloatingHeaderVerify.default, {
      translations: translations,
      isScrolledDown: isScrolledDown
    }), isContestEmpty && /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.EmptyScreen, {})
    }), !isContestEmpty && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [isHowToPlayAboveBanner && /*#__PURE__*/(0, _jsxRuntime.jsx)(_HowToPlay.default, {
          activePickem: activePickem,
          split: activePickem && activePickem.split,
          prizepool: activePickem && activePickem.prizeFund,
          onRulesClicked: onRulesClicked
        }), !process.env.REACT_APP_HIDE_CONTEST_BANNER && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContestBanner.default, {
          isHowToPlayAboveBanner: isHowToPlayAboveBanner,
          onRulesClicked: onRulesClicked,
          translations: translations,
          app: app,
          activePickem: activePickem,
          split: activePickem && activePickem.split,
          prizepool: activePickem && activePickem.prizeFund
        }), hasSocialShareButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScoresShareButton.default, {
          translations: translations
        }), ((activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "UPCOMING" || (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "APPROVED") && isLocked !== undefined && !isLocked && !hideMakeYourPicks && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContestMakePicks.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContestPicks.default, {
          app: app,
          hasQuestionStatBelowQuestion: hasQuestionStatBelowQuestion,
          hasCheckboxes: hasCheckboxes,
          consentCheckboxes: consentCheckboxes,
          setConsetCheckboxes: setConsetCheckboxes,
          onTermsAndConditionsClicked: onTermsAndConditionsClicked,
          translations: translations,
          betbarParent: betbarParent,
          status: activePickem === null || activePickem === void 0 ? void 0 : activePickem.status,
          hidePopularPick: hidePopularPick,
          isUsingAlternativeImages: isUsingAlternativeImages,
          isLocked: process.env.REACT_APP_SCREENSHOT_MODE === "true" || isLocked,
          updatePicks: updatePicks,
          GameBanner: GameBanner
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContestBetNow.default, {
        betbarParent: betbarParent,
        setBetbarParent: setBetbarParent,
        isLoading: isPlacingBet,
        selections: picks,
        consentCheckboxes: consentCheckboxes // placeBet={handlePlaceBet}
        ,
        isOpen: isAllSelected && !activeBet && (!hasCheckboxes || (consentCheckboxes === null || consentCheckboxes === void 0 ? void 0 : consentCheckboxes.over18)),
        onPlaceBetClicked: onPlaceBetClicked
      })]
    })]
  });
};

var _default = Contest;
exports.default = _default;